// extracted by mini-css-extract-plugin
export default {"caption":"uUVXzjuz","credits":"uAiUQVNd"};